import { render, staticRenderFns } from "./UiMenu.vue?vue&type=template&id=c4c85f78&"
import script from "./UiMenu.vue?vue&type=script&lang=ts&"
export * from "./UiMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports